/* eslint-disable react/prop-types */
/* eslint-disable react/prop-types */

import React from "react"
import { Card, Avatar, Badge } from "antd"
import { Link } from "react-router-dom";
import points_icon from "assets/images/icon-points.png";
import { isOnline } from "../../util/DateUtil";
import Icon, { CaretUpOutlined, CaretDownOutlined } from "@ant-design/icons";
import iconBadge from "./../../assets/images/icon-badge.png"
import iconBadgeOff from "./../../assets/images/icon-badge-off.png"
import { range } from "lodash";
function RankChangeSVG(props) {
    return (
      <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        style={{
          stroke:"black",
          strokeWidth:"1px"
        }}
        transform={"rotate(-90)"}
        {...props}
      >
        <path d="M17.428 5H0l6.616 7L0 19h17.428L24 12z" />
      </svg>
    )
  }
  const RankChangeIcon = props => <Icon component={RankChangeSVG} {...props} style={{ color: "rgb(147,253,131)", fontSize: "18px", stroke:"#146d14", strokeWidth:"1px" }}/>;
  const RankChangeDownIcon = props => <Icon component={RankChangeSVG} {...props} rotate= {90} style={{ color: "rgb(253,131,131)", fontSize: "18px", stroke:"#146d14",strokeWidth:"1px"}}/>;

const renderBadgeLevel = badge_level=>{
    const imageSize = "16px"
    
return (<><span style={{fontSize:"12px", color:"#a5a5a5", whiteSpace:"nowrap"}}>{"Badge Level : "}</span>{range(0,4).
            map(badgeIndex=><img key={`badge_icon_${badgeIndex}`} src={(badgeIndex+1)<=badge_level? iconBadge:iconBadgeOff} height={imageSize} width={imageSize}/>)}</>)
}
class LeaderboardCard extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { details = {} } = this.props;
        const { avatar, id, name, is_online =false, rankIndex, monthly_points = "0",monthly_rank,rank_change,badge_level=0 } = details
        console.log(details)
        
        return (<Card bordered={true} style={{ marginBottom: 10, padding: 3 }} 
                    bodyStyle={{ margin: 0, padding: 0,width:"100%" }}>
            <div style={{display:"flex", flexDirection:"row", margin:5}}>
                <div style={{...styles.columnFlex, flex:1}}>
                    <div style={{display:"flex", flexDirection:"row", justifyContent:"flex-start",alignItems: "center"}}>
                            <span style={{fontWeight:"bold", fontSize:"12px",padding:"10px"}}>{`${rankIndex}.  `} </span>
                            <Badge dot color={is_online?"green":"#a1a1a1a1"}>
                                <Avatar src={avatar} size={"large"}/>
                            </Badge>
                    </div>
                </div>
                <div style={{...styles.columnFlex, flex:5, justifyContent:"center", padding:5}}>
                    <div style={{display:"flex", flexDirection:"row", justifyContent:"flex-start",alignItems: "flex-start"}}>
                        <Link to={`/main/student/${id}`} style={{paddingLeft:"5px"}}> {name}</Link>
                    </div>
                    <div style={{...styles.rowFlex, justifyContent:"center",alignItems: "flex-start",paddingTop:"10px"}}>    
                        <div style={{...styles.rowFlex}}>
                            <span style={{fontSize:"12px", color:"#a5a5a5"}}>AIR : {monthly_rank}</span>
                            {rank_change >= 0?<CaretUpOutlined style={{color:"rgb(147,253,131)"}} />:<CaretDownOutlined  style={{color:"rgb(253,131,131)"}} />}
                        </div>
                    </div>
                </div>
                <div style={{...styles.columnFlex, flex:4, justifyContent:"center"}}>
                    <div style={{display:"flex", flexDirection:"row", justifyContent:"flex-end",alignItems: "flex-end"}}>
                        <img src={points_icon}  height={24}/>
                        <span style={{ paddingTop:4}}>{monthly_points}</span>
                    </div>
                    <div style={{display:"flex", flexDirection:"row", justifyContent:"flex-end",alignItems: "flex-end", paddingTop:5}}>
                        {renderBadgeLevel(badge_level)}
                    </div>
                </div>
            </div>
        </Card>)
    }
}

const styles = {
    quizStateTag: { color: "#FFF", padding: "2px 6px", margin: "0px", position: "absolute", top: "5px", right: "10px", borderRadius: "5px", fontSize: "8px",fontWeight:"normal" },
    seperatorRight:{borderRightWidth:"4px",borderRightColor:"rgb(165 165 165 / 25%)",borderRightStyle:"solid", padding:"5px"},
    rowFlex:{display:"flex", flexDirection:"row"},
    columnFlex:{display:"flex", flexDirection:"column"},
    centerColumnFlex:{display:"flex", flexDirection:"column",justifyContent:"center",alignItems: "center", padding: "5px"}
}
export default LeaderboardCard


